import { useWorkspaceNavigate as useNavigate } from '@/contexts/DocumentWorkspace';
import { useNotifications } from '../hooks/useNotifications';

export default function Notifications() {
  const { notifications, unreadCount, markRead, markAllRead } = useNotifications();
  const navigate = useNavigate();
  return (
    <div style={{ maxWidth: 640, margin: '24px auto', padding: 16 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h1 style={{ fontSize: 22 }}>Notifications</h1>
        {unreadCount > 0 && <button onClick={markAllRead}>Mark all read</button>}
      </div>
      {notifications.length === 0 && <p style={{ color: '#888' }}>No notifications yet.</p>}
      {notifications.map((n) => (
        <button key={n.id} onClick={() => { if (!n.read_at) markRead(n.id); if (n.link) navigate(n.link); }}
          style={{ display: 'block', width: '100%', textAlign: 'left', padding: 14, margin: '8px 0', border: '1px solid #e5e7eb', borderRadius: 8, background: n.read_at ? '#fff' : '#eef2ff', cursor: 'pointer' }}>
          <div style={{ fontWeight: n.read_at ? 400 : 700 }}>{n.title}</div>
          {n.body && <div style={{ fontSize: 14, color: '#444', marginTop: 4, whiteSpace: 'pre-wrap' }}>{n.body}</div>}
          <div style={{ fontSize: 12, color: '#888', marginTop: 6 }}>{new Date(n.created_at).toLocaleString()}</div>
        </button>
      ))}
    </div>
  );
}
